import { EllipseAnimation } from '$tablet-app/src/app/components/EllipsisAnimation/EllipsisAnimation';
import PegasusAvatar from '$tablet-app/src/app/components/Pegasus/PegasusAvatar';
import { PulseEffect } from '$tablet-app/src/app/components/PulseEffect';
import { startVoiceListening } from '$tablet-app/src/app/speech-to-text/useSTT';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import { useLoginScreenState } from '../login_screen_state';

type Props = {
  style?: StyleProp<ViewStyle>;
  size?: number;
  onLongPressAvatar?: () => void;
};

export const AvatarComponent = (props: Props) => {
  const { size = 184 } = props;

  const microphone_active = useStateStore((state) => state.listening_to_voice);
  const waiting_for_response = useLoginScreenState(
    (state) => state.waiting_for_response
  );

  return (
    <AvatarSection style={props.style}>
      <AvatarContainer size={size} onLongPress={props.onLongPressAvatar}>
        <PegasusAvatar />
      </AvatarContainer>

      <MicrophoneButtonContainer>
        {microphone_active ? <PulseEffect size={size} /> : null}
        <MicrophoneButton
          size={size / 3}
          onPress={startVoiceListening}
          disabled={microphone_active}
        >
          <FontAwesomeIcon
            icon="microphone"
            size={size / 6}
            color={microphone_active ? colors.primary[700] : undefined}
          />
        </MicrophoneButton>
      </MicrophoneButtonContainer>

      {waiting_for_response ? (
        <EllipsisContainer
          style={{ position: 'absolute', left: size * 1.1, top: 0 }}
        >
          <EllipseAnimation style={{ width: size / 2.4 }} />
        </EllipsisContainer>
      ) : null}
    </AvatarSection>
  );
};

const AvatarContainer = styled.Pressable<{ size: number }>`
  aspect-ratio: 1;
  width: ${({ size }) => size}px;

  border-radius: 200px;

  background-color: white;
  shadow-color: black;
  shadow-opacity: 0.5;
  shadow-radius: 2px;
  elevation: 2;
  overflow: hidden;
`;

const AvatarSection = styled(View)`
  position: relative;
  flex-direction: row;
  gap: 20px;
  align-items: flex-end;
`;

const MicrophoneButtonContainer = styled.View`
  position: relative;
  align-items: center;
  justify-content: center;
`;

const MicrophoneButton = styled.TouchableOpacity<{ size: number }>`
  aspect-ratio: 1;
  width: ${({ size }) => size}px;
  border-radius: ${({ size }) => size / 2}px;
  background-color: white;
  align-items: center;
  justify-content: center;

  shadow-color: black;
  shadow-opacity: 1;
  shadow-radius: 2px;
  elevation: 3;
`;

const EllipsisContainer = styled.View`
  padding: 10px;
  border-radius: 20px;
  border-bottom-left-radius: 0;
  background-color: ${colors.primary[700]};

  margin-bottom: 60px;
`;
